import React, { Component } from 'react';

class PrintOrthodonticExamForm extends Component {

    render() {
        const { customer } = this.props;

        const PrintCheckboxGroup = ({ label, options = [] }) => {
            return (
                <div className="checkbox-inline-row">
                    {label && <strong className="inline-label">{label}: </strong>}

                    {options.map((opt, index) => {
                        const hasDetail = opt.toLowerCase().includes("ghi rõ") || opt.toLowerCase().includes("(mm)");

                        return (
                            <>
                                <div key={index} className="inline-item">
                                    <label className="inline-checkbox">
                                        <input type="checkbox" className="checkbox" /> {opt}
                                    </label>
                                </div>
                                {hasDetail && (
                                    <div key={index} className="inline-item" style={{
                                        width: '100%',
                                        marginRight: 0,
                                        marginLeft: '-10px',
                                        gap: 0
                                    }}>
                                        <label className="inline-checkbox">&nbsp;</label>
                                        <div className="inline-dots">
                                            <span className="dotline"></span>
                                        </div>

                                    </div>

                                )}
                            </>
                        );
                    })}
                </div>
            );
        };

        const renderDot = (value, dot = "..................................................................") => {
            if (value === null || value === undefined || value === "") {
                return dot;
            }
            return value;
        };


        return (
            <div className="container print-content">
                <div className="title-wrap">
                    <div className="print-date-top">
                        Ngày.........tháng.........năm.........
                    </div>
                    <h1>PHIẾU KHÁM CHỈNH NHA</h1>
                </div>
                <table className="kv-table">
                    <tr>
                        <th>Họ và tên khách hàng:</th>
                        <td>{renderDot(customer?.full_name)}</td>
                    </tr>
                    <tr>
                        <th>Mã khách hàng</th>
                        <td>{renderDot(customer?.code)}</td>
                    </tr>
                </table>

                <div className="field-wrapper">
                    <span className="label">I. BĂN KHOĂN CỦA BỆNH NHÂN:</span>
                    <div className="dot-line"></div>
                </div>
                <div className="dotted-lines">
                    <div className="line"></div>
                </div>

                <h2 className="section-title">II. KHÁM TRONG MIỆNG</h2>
                <div className="section-subtitle"><strong>1. Đánh giá tình trạng răng và cung răng</strong></div>
                <div className="mb-2">
                    <PrintCheckboxGroup
                        label="Kích thước cung răng"
                        options={["Hẹp", "Rộng", "Trung bình (hẹp/rộng/trung bình)"]}
                    />
                </div>
                <div className="mb-2">
                    <PrintCheckboxGroup
                        label="Hàm trên: Mức độ chen chúc ước tính"
                        options={["> 7mm", "4-6mm", "<3mm"]}
                    />
                </div>
                <div className="mb-2">
                    <PrintCheckboxGroup
                        label="Hàm dưới: Mức độ chen chúc ước tính"
                        options={["> 7mm", "4-6mm", "<3mm"]}
                    />
                </div>

                <div className="mb-2">
                    <PrintCheckboxGroup
                        label="Khe thưa hàm trên"
                        options={["Không", "Có (ghi rõ chi tiết)"]}
                    />
                </div>
                <div className="mb-2">
                    <PrintCheckboxGroup
                        label="Khe thưa hàm trên"
                        options={["Không", "Có (ghi rõ chi tiết)"]}
                    />
                </div>
                <div className="mb-2">
                    <PrintCheckboxGroup
                        label="Bệnh nhân có thiếu/thừa răng không?"
                        options={["Không", "Có (ghi rõ chi tiết)"]}
                    />
                </div>

                <div className="section-subtitle">
                    <strong>Bệnh nhân có bất thường gì về kích thước / hình dáng / độ xoay lệch răng hoặc bất thường khác cần lưu ý khi chỉnh nha không? (Bác sĩ liệt kê):</strong>
                </div>
                <div className="dotted-lines">
                    <div className="line"></div>
                    <div className="line"></div>
                </div>

                <div className="section-subtitle"><strong>2. Đánh giá tình trạng khớp cắn</strong></div>
                <div className="field-wrapper">
                    <span className="label">Độ trùm (mm):</span>
                    <div className="dot-line"></div>
                </div>
                <div className="field-wrapper">
                    <span className="label">Độ chìa (mm):</span>
                    <div className="dot-line"></div>
                </div>


                <div className="section-subtitle"><strong>Khớp cắn bên trái</strong></div>
                <PrintCheckboxGroup
                    label="Răng 3"
                    options={["Răng 1", "Răng 2 (mm)", "Răng 3 (mm)"]}
                />
                <PrintCheckboxGroup
                    label="Răng 6"
                    options={["Răng 1", "Răng 2 (mm)", "Răng 3 (mm)"]}
                />

                <div className="section-subtitle"><strong>Khớp cắn bên phải</strong></div>
                <PrintCheckboxGroup
                    label="Răng 3"
                    options={["Răng 1", "Răng 2 (mm)", "Răng 3 (mm)"]}
                />
                <PrintCheckboxGroup
                    label="Răng 6"
                    options={["Răng 1", "Răng 2 (mm)", "Răng 3 (mm)"]}
                />

                <PrintCheckboxGroup
                    label="Đường cong spee"
                    options={["Bình thường", "Sâu"]}
                />
                <PrintCheckboxGroup
                    label="Mặt phẳng cắn"
                    options={["Bình thường", "Nghiêng (ghi rõ chi tiết)"]}
                />
                <PrintCheckboxGroup
                    label="Loại mô nha chu"
                    options={["Bình thường", "Dày", "Mỏng"]}
                />
                <PrintCheckboxGroup
                    label="Cắn lệch chức năng"
                    options={["Có", "Không"]}
                />

                <div className="field-wrapper mt-4">
                    <span className="label">Bệnh nhân có bất thường gì về khớp cắn khác cần lưu ý khi chỉnh nha không? (Bác sĩ liệt kê):</span>
                    <div className="dot-line"></div>
                </div>
                <div className="dotted-lines">
                    <div className="line"></div>
                    <div className="line"></div>
                </div>

                <div className="section-subtitle"><strong>3. Các ghi chú và quan sát khác</strong></div>
                <PrintCheckboxGroup
                    label="Kích thước lưỡi"
                    options={["Bình thường", "To"]}
                />
                <PrintCheckboxGroup
                    label="Tật đẩy lưỡi"
                    options={["Có", "Không"]}
                />

                <div className="field-wrapper mt-4">
                    <span className="label">Quan sát hoặc lưu ý khác của bác sĩ về bệnh nhân mà cần được cân nhắc trong quá trình chỉnh nha? (Bác sĩ liệt kê):</span>
                    <div className="dot-line"></div>
                </div>
                <div className="dotted-lines">
                    <div className="line"></div>
                    <div className="line"></div>
                </div>

                <h2 className="section-title">III. KHÁM NGOÀI MẶT</h2>
                <div className="section-subtitle"><strong>1. Đánh giá mặt thẳng ở tư thế nghỉ</strong></div>
                <PrintCheckboxGroup
                    label="Dạng mặt thẳng"
                    options={["Bình thường", "Mặt ngắn", "Mặt dài"]}
                />
                <PrintCheckboxGroup
                    label="Độ cân đối của cằm"
                    options={["lệch", "Không lệch"]}
                />
                <PrintCheckboxGroup
                    label="Tương quan tầng mặt dưới so với tổng thể khuôn mặt"
                    options={["Hài hòa", "Ngắn", "Dài"]}
                />
                <PrintCheckboxGroup
                    label="Môi có khép kín ở tư thế nghỉ hay không"
                    options={["Có", "Không"]}
                />
                <PrintCheckboxGroup
                    label="Rãnh môi cằm"
                    options={["Bình thường", "Thấy rõ", "Không thấy"]}
                />

                <div className="field-wrapper mt-4">
                    <span className="label">Ngoài ra có bất thường gì nổi trội khác hay không?</span>
                    <div className="dot-line"></div>
                </div>
                <div className="dotted-lines">
                    <div className="line"></div>
                    <div className="line"></div>
                </div>

                <div className="section-subtitle"><strong>2. Đánh giá mặt thẳng ở tư thế cười</strong></div>
                <PrintCheckboxGroup
                    label="Đường cười"
                    options={["Bình thường", "Cao", "Thấp"]}
                />
                <PrintCheckboxGroup
                    label="Cười lộ nướu"
                    options={["Không", "Có (mm)"]}
                />
                <PrintCheckboxGroup
                    label="Hành lang má"
                    options={["Bình thường", "Tối"]}
                />
                <PrintCheckboxGroup
                    label="Đường giữa"
                    options={["Không lệch", "Lệch (mm)"]}
                />
                <div className="field-wrapper mt-4">
                    <span className="label">Ngoài ra có bất thường gì nổi trội khác hay không?</span>
                    <div className="dot-line"></div>
                </div>
                <div className="dotted-lines">
                    <div className="line"></div>
                    <div className="line"></div>
                </div>

                <div className="section-subtitle"><strong>3. Đánh giá mặt nghiêng ở tư thế nghỉ</strong></div>
                <PrintCheckboxGroup
                    label="Dạng mặt nghiêng"
                    options={["Lồi", "Lỗm", "Thẳng"]}
                />
                <PrintCheckboxGroup
                    label="Góc môi trên"
                    options={["Bình thường", "Tù", "Nhọn"]}
                />
                <PrintCheckboxGroup
                    label="Vị trí cằm"
                    options={["Bình thường", "Ra trước", "Lùi sau"]}
                />
                <PrintCheckboxGroup
                    label="Góc mặt phẳng hàm dưới"
                    options={["Bình thường", "Đóng", "Mở"]}
                />
                <PrintCheckboxGroup
                    label="Lõm môi cằm"
                    options={["Bình thường", "Thấy rõ", "Không thấy"]}
                />
                <PrintCheckboxGroup
                    label="Hình thái môi"
                    options={["Bình thường", "Dày", "Mỏng"]}
                />
                <div className="field-wrapper mt-4">
                    <span className="label">IV. HƯỚNG ĐIỀU TRỊ SƠ BỘ</span>
                    <div className="dot-line"></div>
                </div>
                <div className="dotted-lines">
                    <div className="line"></div>
                    <div className="line"></div>
                </div>

                <div className="signature-section mt-4">
                    <div className="sig-box">
                        <strong>Bác sĩ</strong>
                        <span className="note">(Ký, ghi rõ họ tên)</span>
                        <div className="sig-space"></div>
                        <div className="sig-name"></div>
                    </div>

                    <div className="sig-box">
                        <strong>Khách hàng</strong>
                        <span className="note">(Ký, ghi rõ họ tên)</span>
                        <div className="sig-space"></div>
                        <div className="sig-name">{customer?.full_name}</div>
                    </div>
                </div>


                <style>
                    {`
                        /* --- Print & Page setup --- */
                        @page {
                            size: A4;
                           margin: 0.8cm 0.5cm 0.8cm 0.5cm; /* top, right, bottom, left */
                        }

                        :root {
                            --text: #111;
                            --muted: #666;
                            --border: #ddd;
                            --heading: #000;
                            --primary: #0b2b33;
                        }

                        @media print {
                            .no-print {
                                display: none !important;
                            }

                            .page-break {
                                page-break-before: always;
                            }

                            body {
                                font-family: "Times New Roman", serif;
                                font-size: 11pt;
                                line-height: 1.5;
                                color: #000;
                                overflow-y: hidden;
                            }
                            .print-date-top{
                                margin-top: -5mm;
                            }
                        }

                        .print-date-top{
                            margin-bottom: 10px;
                            text-align: right;
                            font-style: italic;
                        }

                        .field-wrapper {
                            display: flex;
                            align-items: center;
                            width: 100%;
                        }

                        .field-wrapper .label {
                            font-weight: 600;  /* theo style subtitle của bạn */
                            margin-right: 0;
                            white-space: nowrap;
                        }

                        .field-wrapper .dot-line {
                            flex: 1;
                            border-bottom: 1px dotted #000;
                            height: 1px;
                            margin-top: 8px; /* căn cho đẹp */
                        }

                        .dotted-lines .line {
                            border-bottom: 1px dotted #000;
                            height: 16px;       /* chiều cao mỗi dòng */
                            margin-bottom: 2px; /* khoảng cách giữa các dòng */
                            width: 100%;
                        }

                        .container {
                            max-width: 800px;
                            margin: 0 auto;
                            padding: 0px;
                            position: relative;
                        }

                        .checkbox-inline-row {
                            display: flex;
                            align-items: center;
                            flex-wrap: nowrap;
                            width: 100%;
                            margin-bottom: 6px;
                        }

                        .inline-label {
                            margin-right: 10px;
                            white-space: nowrap;
                        }

                        .inline-item {
                            display: flex;
                            align-items: center;
                            gap: 10px;
                            white-space: nowrap;
                            margin-right: 10px;
                        }

                        .inline-checkbox {
                            display: flex;
                            align-items: center;
                            white-space: nowrap;
                        }

                        .checkbox {
                            width: 15px;
                            height: 15px;
                            margin-right: 6px;
                        }

                        .inline-dots {
                            display: flex;
                            flex-direction: column;
                            flex-grow: 1;
                        }

                        .dotline {
                            border-bottom: 1px dotted #000;
                            height: 16px;
                            display: block;
                            margin-top: -6px;
                            width: 100%;
                        }



                        .print-content h1,
                        .print-content h2,
                        .print-content h3 {
                            margin: 0 0 10px 0;
                            color: var(--heading);
                        }

                        .print-content h1 {
                            text-align: center;
                            font-size: 18pt;
                            letter-spacing: 0.3px;
                        }

                        .print-content h2.section-title {
                            font-size: 13.5pt;
                            /* border-left: 4px solid var(--primary);
                            padding-left: 8px; */
                            margin: 18px 0 10px 0;
                        }

                        .print-content .line-height-20{
                            line-height: 20px;
                        }
                        .subtitle {
                            color: var(--muted);
                            font-style: italic;
                            font-weight: normal;
                            margin-left: 6px;
                            font-size: 11.5pt;
                        }

                        /* --- Header --- */
                    .header {
                        display: flex;
                        align-items: flex-start;
                        justify-content: space-between;
                        margin-bottom: 20px;
                        border-bottom: 1px solid var(--border);
                        padding-bottom: 20px;
                        position: relative;
                    }

                    /* Nhóm bên phải (QR + thông tin) */
                    .header .footer {
                        display: flex;
                        align-items: flex-start;
                        gap: 16px;
                        border: none;
                        padding-top: 0;
                        margin-top: 0;
                    }

                    /* Logo */
                    .logo-box {
                        width: 90px;
                        height: 90px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                    }

                    .logo-box img {
                        max-width: 100%;
                        max-height: 100%;
                        object-fit: contain;
                    }

                    /* QR */
                    .header .footer .qr-box {
                        width: 80px;
                        height: 80px;
                        flex-shrink: 0;
                    }

                    .header .footer .qr-box img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                        border: 1px solid var(--border);
                        background: #fff;
                        padding: 4px;
                    }

                    /* Clinic info */
                    .header .footer .clinic {
                        text-align: left;
                        margin-left: 8px;
                        font-size: 10.5pt;
                        line-height: 1.4;
                    }

                    .header .footer .clinic .section-title {
                        font-weight: bold;
                        color: var(--primary);
                        margin-bottom: 4px;
                        font-size: 11pt;
                    }

                    .header .footer .clinic span {
                        display: block;
                        font-size: 8px;
                        color: var(--muted);
                        line-height: 1.3;
                    }
                        .title-wrap {
                            margin: 8px 0 16px 0;
                            position: relative;
                        }

                        /* --- Tables --- */
                        table {
                            border-collapse: collapse;
                            width: 100%;
                        }

                        .kv-table td,
                        .kv-table th {
                            border: 0px solid var(--border);
                            padding: 5px 0px;
                            vertical-align: top;
                        }

                        .kv-table th {
                            width: 32%;
                            /* background: #fafafa; */
                            text-align: left;
                            font-weight: 600;
                        }

                        .grid-table th,
                        .grid-table td {
                            border: 1px solid var(--border);
                            padding: 6px 8px;
                            vertical-align: top;
                        }

                        .grid-table th {
                            background: #fafafa;
                        }

                        .narrow td,
                        .narrow th {
                            padding: 5px 6px;
                        }

                        .muted {
                            color: var(--muted);
                        }

                        /* --- Helpers --- */
                        .mb-4 {
                            margin-bottom: 16px;
                        }

                        .mb-2 {
                            margin-bottom: 8px;
                        }

                        .mt-2 {
                            margin-top: 8px;
                        }

                        .mt-4 {
                            margin-top: 16px;
                        }

                        .pt-2 {
                            padding-top: 8px;
                        }

                        .pt-4 {
                            padding-top: 16px;
                        }

                        .pl-2 {
                            padding-left: 8px;
                        }

                        .pl-4 {
                            padding-left: 16px;
                        }

                        .pr-2 {
                            padding-right: 8px;
                        }

                        .pr-4 {
                            padding-right: 16px;
                        }

                        .italic {
                            font-style: italic;
                        }

                        .center {
                            text-align: center;
                        }

                        .right {
                            text-align: right;
                        }

                        .note {
                            color: var(--muted);
                        }

                        .image-strip {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 8px;
                            border: 1px dashed var(--border);
                            padding: 10px;
                            min-height: 48px;
                        }

                        .image-thumb {
                            width: 110px;
                            height: 85px;
                            border: 1px solid var(--border);
                            display: inline-flex;
                            align-items: center;
                            justify-content: center;
                            font-size: 10pt;
                            color: var(--muted);
                            background: #fff;
                        }

                        /* --- Textareas-like blocks --- */
                        .textblock {
                            min-height: 64px;
                            border: 1px solid var(--border);
                            padding: 8px;
                            white-space: pre-wrap;
                        }

                        .textblock.tall {
                            min-height: 96px;
                        }

                        .disease-grid {
                            display: flex;
                            gap: 16px;
                            justify-content: space-between;
                        }

                        .disease-column {
                            flex: 1;
                        }

                        .disease-column table {
                            width: 100%;
                        }

                        .disease-column td strong {
                            margin-right: 4px;
                            color: var(--primary);
                        }

                        @media print {
                            .disease-grid {
                                page-break-inside: avoid;
                            }
                        }

                        .bite-item {
                            justify-content: space-between;
                            padding: 6px 0;
                        }

                        .bite-item:last-child {
                            border-bottom: none;
                        }

                        .bite-label {
                            flex: 1;
                            color: var(--text);
                        }

                        .bite-value {
                            min-width: 60px;
                            text-align: right;
                            font-weight: bold;
                            color: var(--primary);
                        }

                        .section-subtitle {
                            font-size: 12.5pt;
                            margin-bottom: 6px;
                        }

                        .print-date {
                            text-align: right;
                            margin-top: 40px;
                            font-size: 12pt;
                            font-style: italic;
                            color: var(--text);
                        }

                        .signature-section {
                            display: flex;
                            justify-content: space-between;
                            align-items: flex-start;
                            margin-top: 30px;
                            text-align: center;
                            gap: 60px;
                            margin-bottom: 50px;
                        }

                        .sig-box {
                            flex: 1;
                        }

                        .sig-box strong {
                            font-size: 13pt;
                            display: block;
                            margin-bottom: 2px;
                        }

                        .sig-box .note {
                            color: var(--muted);
                            font-style: italic;
                            font-size: 11pt;
                        }

                        .sig-space {
                            height: 60px;
                            margin: 24px auto 8px auto;
                            width: 80%;
                        }

                        .sig-name {
                            font-weight: bold;
                            font-size: 12pt;
                            color: var(--primary);
                            text-transform: uppercase;
                        }
                    `}
                </style>
            </div >
        );
    }
}

export default PrintOrthodonticExamForm;
